import React from 'react';
import HomeHeader from '../Header/HomeHeader';
import HomeBody from './HomeBody';
import Footer from './Footer';

const Home = () => {
  return (
    <div>
    <HomeHeader></HomeHeader>
    <HomeBody></HomeBody>
    <Footer></Footer>
    </div>
  )
}

export default Home
